import React from 'react';
import { IUseExploreResult } from './useExplore';

// @ts-ignore
export const ExploreScreenContext = React.createContext<IUseExploreResult>(null);
